import React from "react"
import * as Icon from "react-feather"
const navigationConfig = [
  {
    type: "groupHeader",
    groupTitle: "Gestão",
    permissions: ["admin", "editor"],
  },
  {
    id: "product",
    title: "Produtos",
    type: "item",
    icon: <Icon.Layers size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/products"
  },
  {
    id: "category",
    title: "Categoria",
    type: "item",
    icon: <Icon.Type size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/category"
  },
  {
    type: "groupHeader",
    groupTitle: "Estoque",
    permissions: ["admin", "editor"],
  },
  {
    id: "inOut",
    title: "Entrada / Saida",
    type: "item",
    icon: <Icon.Maximize2 size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/productInOut"
  },
  {
    id: "page3",
    title: "Apontamento",
    type: "item",
    icon: <Icon.Archive size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/productOut"
  },
  {
    id: "page5",
    title: "Expedição",
    type: "item",
    icon: <Icon.Box size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/expedition"
  },
  {
    type: "groupHeader",
    groupTitle: "Relatórios",
    permissions: ["admin", "editor"],
  },
  {
    id: "page4",
    title: "Apontamento",
    type: "item",
    icon: <Icon.File size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/report/productOut"
  },
  {
    id: "page45",
    title: "Expedição",
    type: "item",
    icon: <Icon.File size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/report/productOutExpedition"
  }
]

export default navigationConfig
